/*
Account menu.

HTML Usage:
<account-menu data-options='{}'>
  Account menu
</account-menu>
*/

if (!customElements.get('account-menu')) {
  class AccountMenu extends ToggleElementClass {
    constructor() {
      super();

      // Options
      this.options = {
        menuInner: '.account__menu-inner',
        menuItem: '.account__menu-item',
        menuItemLink: '.account__menu-item a',
        toggleClasses: ['orders-history', 'addresses', 'points', 'logout', 'referral'],
      };

      if (this?.dataset?.options) {
        const dataOptions = JSON.parse(this.dataset.options);
        this.options = {
          ...this.options,
          ...dataOptions,
        };
      }

      this.init();
    }

    init() {
      this.menuItemLinks = this.querySelectorAll(this.options.menuItemLink);

      this.menuItemLinks.forEach((link) => {
        link.addEventListener('click', this.handleMenuItemClick.bind(this));
      });

      // When on the account template
      if (document.body.classList.contains('template-customers-account')) {
        const view = new URLSearchParams(window.location.search).get('view') || 'orders-history';
        this.toggleClasses(view);
      }
    }

    toggleClasses(addClass) {
      this.options.toggleClasses.forEach((option) => {
        document.body.classList.remove(option);
      });
      if (addClass) {
        document.body.classList.add(addClass);
      }
    }

    handleMenuItemClick(event) {
      event.preventDefault();

      let clickedUrl = new URL(event.target.href);
      let currentUrl = new URL(window.location.href);

      // When already on the account page
      if (clickedUrl.pathname === currentUrl.pathname) {
        // Toggle the class on the body
        this.toggleClasses(event.target.dataset.menuItem);
        // Update the url with the new view
        const newUrl = `${clickedUrl.pathname}?view=${event.target.dataset.menuItem}`;
        window.history.pushState({}, '', newUrl);
      } else {
        // When not on the account page, redirect to the href
        window.location.href = event.target.href;
      }
    }
  }

  window.AccountMenu = AccountMenu;

  customElements.define('account-menu', AccountMenu);
}
